export default __webpack_public_path__ + "static/media/spanish.f209e86c.png";